module.exports = __webpack_public_path__ + "media/src/images/partners/pavia-70c77110e2bc07476a3b9754c3ec51ac.jpg";